import React from 'react';

export const RecurringIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M15.49 23.48a7.87 7.87 0 0 1-7.75-8.05l3.17.98-2.77-5.29L3 13.97l3.28 1.01A9.37 9.37 0 0 0 15.49 25c2.29 0 4.44-.86 6.12-2.38l-.98-1.14a7.57 7.57 0 0 1-5.14 2zM28 16.92l-3.28-.98.01-.44c0-5.25-4.14-9.5-9.24-9.5-2.12 0-4.14.74-5.77 2.08l.93 1.19a7.55 7.55 0 0 1 4.84-1.75 7.87 7.87 0 0 1 7.76 7.98l-3.18-.95 2.82 5.26z"
			fill="currentColor"
		/>
	</svg>
);
